import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './translations/en.json';
import frTranslation from './translations/fr.json';

const savedLang = localStorage.getItem('i18nextLng') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      fr: { translation: frTranslation }
    },
    lng: savedLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    interpolation: {
      escapeValue: false
    }
  });

// <html lang> suit la langue choisie dans l'application : le navigateur sait
// ainsi dans quelle langue est vraiment la page (voir aussi translate="no"
// dans public/index.html).
document.documentElement.lang = (i18n.language || 'en').split('-')[0];

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  document.documentElement.lang = lng.split('-')[0];
});

export default i18n;
